/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_RemovedInputs */

const vi_einvoice_credential_removed = /** @type {(inputs: Einvoice_Credential_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gỡ tài khoản MISA khỏi ERP.`)
};

/**

* @param {Einvoice_Credential_RemovedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_removed = /** @type {((inputs?: Einvoice_Credential_RemovedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_RemovedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_removed(inputs)
});